import * as React from 'react';
import { DefaultCard } from '#components/coverage-details-card-variants/default-card-variant.component.tsx';
import type { CoverageDetailsWidgetCardComponentProps } from '#types/coverage-detail-widget-cards.types.ts';
import { SmallIconCard } from '#components/coverage-details-card-variants/small-icon-card-variant.component.tsx';
import { VisitCountCard } from '#components/coverage-details-card-variants/visit-count-card-variant.component.tsx';

export function CoverageDetailsWidgetCard({
  card,
  headingId,
  onClick: onClickCallback,
  href,
}: CoverageDetailsWidgetCardComponentProps) {
  const { image, description, cta, variant, title, badge } = card;
  const ctaId = `${headingId}-cta`;
  const ctaLabelledbyId = headingId ? `${ctaId} ${headingId}` : undefined;

  const handleOnClick = React.useCallback(
    (event: React.SyntheticEvent) => {
      if (onClickCallback) {
        onClickCallback(event);
      }
    },
    [onClickCallback],
  );

  if (!variant) {
    return null;
  }

  if (variant === 'smallIconCard') {
    return (
      <SmallIconCard
        image={image}
        title={title ?? ''}
        indicator={cta?.indicator}
        href={href}
        onClick={handleOnClick}
      />
    );
  }

  if (variant === 'visitCountCard') {
    return (
      <VisitCountCard
        title={title ?? ''}
        badgeLabel={badge?.label ?? ''}
        badgeStatus={badge?.status ?? 'neutral'}
        ctaIndicator={cta?.indicator}
        ctaLabel={cta?.label}
        href={href}
        onClick={handleOnClick}
        description={description}
      />
    );
  }

  return (
    <DefaultCard
      image={image}
      description={description}
      ctaIndicator={cta?.indicator}
      ctaLabel={cta?.label}
      ctaLabelledbyId={cta?.isCtaGeneric ? ctaLabelledbyId : undefined}
      ctaId={cta?.isCtaGeneric ? ctaId : undefined}
      href={href}
      onClick={handleOnClick}
    />
  );
}
